"use client";
import React, { useEffect } from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import Heading from "@/app/_components/Heading";

const ResetSuccessful = () => {
  const router = useRouter();

  useEffect(() => {
    const timer = setTimeout(() => {
      router.push("/login");
    }, 3000);

    return () => clearTimeout(timer);
  }, [router]);

  return (
    <div className="flex max-w-120 flex-col">
      <Image
        className="mb-8 p-1.5"
        src={"/images/check.svg"}
        height={62}
        width={62}
        alt="success"
      />
      <Heading size="3xl" className="text-text-900 mb-3">
        Your password was successfully updated!
      </Heading>
      <p className="text-body-medium/md text-text-700 mb-10.5">Redirecting to login...</p>
    </div>
  );
};

export default ResetSuccessful;
